import * as React from 'react';

import { PaymentsTableWrapper } from './PaymentsTable';

export const Payments = () => {
  return <PaymentsTableWrapper />;
};
